import { useContext, useState } from 'react'
import { bool, object, string } from 'prop-types'

import { Alert, Select, Stack } from 'ui/baseComponents'
import { constructRoleVariables, useUpdateMembership } from '../mutations'
import { useRefetchUsers } from '../queries'
import { UserPHIContext } from 'ui/contexts'

export const UserTypeSwitch = ({
  membershipId,
  admin: adminProp,
  membershipRole: roleProp,
  disabled,
}) => {
  const phiVisibility = useContext(UserPHIContext)

  const [error, setError] = useState()
  const [updateMembership, { loading }] = useUpdateMembership({
    onError: (error) => {
      setError(error)
    },
    refetchQueries: [useRefetchUsers()],
  })
  const role = roleProp

  const onAdminChange = (event) => {
    const toggleVal = event.target.value
    const [adminVal, canSeePHIVal] = constructRoleVariables(toggleVal)
    updateMembership({
      variables: {
        input: {
          admin: adminVal,
          canSeePHI: canSeePHIVal,
          membershipId: membershipId,
        },
      },
    })
  }

  const handleClose = () => {
    setError(false)
  }

  const options = [
    {
      key: 'admin',
      name: 'Admin',
      value: 'Admin',
      'data-cy': 'user-list-role-option-admin',
    },
    {
      key: 'clinician',
      name: 'Clinician',
      value: 'Clinician',
      disabled: !phiVisibility,
      'data-cy': 'user-list-role-option-clinician',
    },
    {
      key: 'member',
      name: 'User',
      value: 'Member',
      'data-cy': 'user-list-role-option-member',
    },
  ]

  return (
    <>
      <Stack direction="row" alignItems="flex-start">
        <Select
          value={
            role !== null ? role?.displayName : adminProp ? 'Admin' : 'Member'
          }
          onChange={onAdminChange}
          disabled={loading || disabled}
          data-cy="user-list-role-select"
          label="Role"
          options={options}
          showLabel={false}
          variant="standard"
        ></Select>
      </Stack>
      {error && (
        <Alert onClose={handleClose} severity="error">
          Unable to update User Type
        </Alert>
      )}
    </>
  )
}

UserTypeSwitch.propTypes = {
  membershipId: string.isRequired,
  admin: bool.isRequired,
  membershipRole: object.isRequired,
  disabled: bool,
}
